import React, { useMemo } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Modal,
  ScrollView,
  Image
} from "react-native";
import SuccessIcon from "../../../../../../../../assets/images/success-icon-arrow.png";
import Colors from "../../../../../constants/colors";
import VintageClock from "../../../../../../../../assets/images/Vintage-Clock.png";
import CashRegister from "../../../../../../../../assets/images/Cash-Register.png";
import DiscountIcon from "../../../../../../../../assets/images/Discount.png";
import LeftAlign from "../../../../../../../../assets/images/Left-align.png";
import PeopleAddIcon from "../../../../../../../../assets/images/People-Add.png";
import LocationMap from "../../../../../../../../assets/images/Location-Map.png";
import EnglishFlag from "../../../../../../../../assets/images/english-flag.png"
import { useSessionStore } from "../../../../../../../state/src/useSessionStore";
import type { SessionState } from "../../../../../../../state/src/useSessionStore";


interface TransferSummaryModalProps {
  visible: boolean;
  onClose: () => void;
  receiverName: string;
  amount: string; // e.g. "9,365.58 MXN"
  status?: string; // e.g. "Processing"
  paymentMethod?: string; // e.g. "Bank account •••• 1188"
  exchangeRate?: string; // e.g. "1 USD = 18.73 MXN"
  fees?: string; // e.g. "0.00"
  youSent?: string; // e.g. "$500.00 USD"
  total?: string; // e.g. "500.00 USD"
  receiveMethod?: string; // e.g. "Debit card •••• 1188"
}

const TransferSummaryModal: React.FC<TransferSummaryModalProps> = ({
  visible,
  onClose,
  receiverName,
  amount,
  status = "Processing",
  paymentMethod,
  exchangeRate,
  fees,
  youSent,
  total,
  receiveMethod,
}) => {
  console.log('amount==>', amount)
  const finalValidationResponse = useSessionStore((s: SessionState) => (s as any).finalSendValidationResponseStore);
  const sendAmountFromValidation = useMemo(() => {
    try {
      const raw = finalValidationResponse && ((finalValidationResponse as any).data !== undefined ? (finalValidationResponse as any).data : finalValidationResponse);
      const sendAmt = raw?.SendAmounts?.SendAmount ?? raw?.sendAmounts?.sendAmount ?? undefined;
      return typeof sendAmt === 'number' ? sendAmt.toFixed(2) : (typeof sendAmt === 'string' ? sendAmt : undefined);
    } catch { return undefined; }
  }, [finalValidationResponse]);
  return (
    <Modal
      visible={visible}
      animationType="slide"
      presentationStyle="pageSheet"
      onRequestClose={onClose}
    >
      <View style={styles.container}>
        {/* Close button */}
        <TouchableOpacity style={styles.closeBtn} onPress={onClose}>
          <Text style={{ fontSize: 20 }}>✕</Text>
        </TouchableOpacity>

        <ScrollView contentContainerStyle={styles.scroll}>
           <View style={{ alignItems: 'center'}}>
            <Image source={SuccessIcon} style={styles.successIconStyle} />
            {/* <Text style={styles.circleText}>{receiverName?.[0] ?? "?"}</Text> */}
          

            {/* Receiver + Amount */}
            <Text style={styles.receiverLine}>{receiverName} will receive</Text>
            <Text style={styles.amount}>{amount}</Text>
          </View>

          {/* Transfer Details */}
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Transfer details</Text>
            <View style={styles.sectionBlock}>
              <Image source={VintageClock} style={styles.leftIcons} />
              <View>
                <Text style={styles.label}>Status:</Text>
                <Text style={styles.value}>{finalValidationResponse?.ReadyForCommit ? "Processing" : "Failed"}</Text>
              </View>
            </View>
             <View style={styles.sectionBlock}>
              <Image source={CashRegister} style={styles.leftIcons} />
              <View>
                <Text style={styles.label}>Payment</Text>
                <Text style={styles.value}>{paymentMethod}</Text>
              </View>
            </View>

            <View style={styles.sectionBlock}>
              <Image source={DiscountIcon} style={styles.leftIcons} />
              <View>
                <Text style={styles.label}>Exchange rate</Text>
                <Text style={styles.value}>{finalValidationResponse?.ExchangeRateApplied}</Text>
              </View>
            </View>

            <View style={styles.sectionBlock}>
              <Image source={LeftAlign} style={styles.leftIcons} />
              <View>
                <Text style={styles.label}>Fees</Text>
                <Text style={styles.value}>{finalValidationResponse?.SendAmounts?.TotalSendFees}</Text>
              </View>
            </View>

            <View style={styles.sectionBlock}>
              <Image source={EnglishFlag} style={[styles.leftIcons, { borderRadius: 50}]} />
              <View>
                <Text style={styles.label}>You sent</Text>
                <Text style={styles.value}>{finalValidationResponse?.SendAmounts?.SendAmount && finalValidationResponse?.SendAmounts?.SendCurrency ? `$${finalValidationResponse?.SendAmounts?.SendAmount} ${finalValidationResponse?.SendAmounts?.SendCurrency}` : youSent}</Text>
              </View>
            </View>

            <View style={styles.sectionBlock}>
              {/* <Image source={EnglishFlag} style={styles.leftIcons} /> */}
              <View>
                <Text style={styles.label}>Total (includes fees*)</Text>
                <Text style={styles.value}>{finalValidationResponse?.SendAmounts?.
TotalAmountToCollect} </Text>
              </View>
            </View>
          </View>

          {/* Receiver Details */}
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Receiver details</Text>
            <View style={styles.sectionBlock}>
              <Image source={PeopleAddIcon} style={styles.leftIcons} />
              <View>
                <Text style={styles.label}>Legal name</Text>
                <Text style={styles.value}>{receiverName}</Text>
              </View>
            </View>

            <View style={styles.sectionBlock}>
              <Image source={LocationMap} style={styles.leftIcons} />
              <View>
                <Text style={styles.label}>How they receive</Text>
                <Text style={styles.value}>{receiveMethod}</Text>
              </View>
            </View>
          </View>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default TransferSummaryModal;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
  closeBtn: {
    alignSelf: "flex-end",
    padding: 24,
  },
  scroll: {
    paddingHorizontal: 24,
    paddingBottom: 40,
    // alignItems: "center",
  },
  circleAvatar: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: "#eee",
    marginBottom: 24,
  },
  successIconStyle: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: "#eee",
    marginBottom: 24,
  },
  receiverLine: {
    fontFamily: 'Rubik',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 22,
    color: Colors.titleTextColor,
    marginBottom: 2,
  },
  amount: {
    fontSize: 24,
    fontWeight: "500",
    marginBottom: 24,
    fontFamily: 'Rubik',
    lineHeight: 30,
    color: Colors.titleTextColor,
  },
  section: {
    width: "100%",
    borderTopWidth: 1,
    borderTopColor: "#ddd",
    paddingVertical: 36,
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: "500",
    marginBottom: 12,
    fontFamily: 'Rubik',
    lineHeight: 26,
    color: Colors.titleTextColor,
  },
  sectionBlock: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 12,
  },
  leftIcons: {
    width: 24,
    height: 24,
    marginRight: 20
  },
  label: {
    fontSize: 16,
    fontWeight: "500",
    // marginTop: 12,
    marginBottom: 4,
    fontFamily: 'Rubik',
    lineHeight: 24,
    color: Colors.titleTextColor,
  },
  value: {
    fontSize: 14,
    fontWeight: "400",
    fontFamily: 'Rubik',
    lineHeight: 16,
    color: Colors.infoSubValue,
  },
});